module.exports = __webpack_public_path__ + "static/MineralSwimV2_Brochure_ONLINEonly-b752188c9fd66cfd0eca7438b4c775a4.pdf";